"use strict";
/**
 * Sport-generic buy-button wiring.
 *
 * Attaches the shared two-stage arm/confirm behavior to a sport's buy
 * buttons and routes each confirmed click to the right order path:
 * additional-only (EXT), combined-mode per-button manual price, or
 * factor-scaled slippage. Sport modules supply `SportBuySpec[]` tables.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSportBuyButtons = setupSportBuyButtons;
const state_1 = require("../../../state");
const ui_1 = require("../../../ui");
const order_placement_1 = require("../order-placement");
const two_stage_click_1 = require("../two-stage-click");
const pricing_1 = require("./pricing");
/**
 * Wire up a sport's buy buttons with the shared two-stage-confirm UX.
 *
 * The confirmed-click handler is hot-path sensitive: one `getState()`, no
 * awaits, no logging — identical in shape to the traditional buttons.
 *
 * @param specs            - The sport's buy buttons
 * @param allButtons       - All standard order buttons (for mutual-exclusion reset)
 * @param sportButtons     - All sport-layout buttons (for mutual-exclusion reset)
 * @param armTimeoutId     - Shared arm-timeout ref
 * @param isConfirmRequired - Callback returning current two-stage-confirm state
 */
function setupSportBuyButtons(specs, allButtons, sportButtons, armTimeoutId, isConfirmRequired) {
    for (const spec of specs) {
        if (!spec.btn)
            continue;
        (0, two_stage_click_1.attachTwoStageExecution)(spec.btn, {
            armTimeoutId,
            resetButtons: [allButtons, sportButtons],
            isConfirmRequired,
            onExecute: () => {
                if (spec.kind === "additional-only") {
                    (0, order_placement_1.handlePlaceAdditionalOnlyOrder)(spec.buttonId);
                    return;
                }
                const { tradingSettings } = (0, state_1.getState)();
                // Combined mode: use the per-button manual price (main buttons only, not MISC/EXT)
                if (spec.meta && (0, ui_1.isCombinedPricingMode)(tradingSettings)) {
                    const stored = tradingSettings.baseballButtonManualPrices?.[spec.meta.key];
                    const price = stored !== undefined ? stored : (0, pricing_1.getAskPrice)(spec.meta.side);
                    (0, order_placement_1.handlePlaceOrder)(spec.side, "buy", undefined, spec.buttonId, price);
                    return;
                }
                const factor = tradingSettings.baseballFactor ?? 0;
                (0, order_placement_1.handlePlaceOrder)(spec.side, "buy", spec.getSlippage(factor), spec.buttonId);
            },
        });
    }
}
